import mapboxgl from 'mapbox-gl'
import 'mapbox-gl/dist/mapbox-gl.css'
import MapboxLanguage from '@mapbox/mapbox-gl-language'
import request from 'axios'
import keyborad from './tool/keyborad'
import Layer from './layer'
let Mapbox = {
  /**
   * 初始化mapbox,初始化deck
   *
   * @param {String} el echart挂载实例
   * @param {Object} config 配置
   * @returns
   */
  async init(el, config) {
    this.type = config.type || 'vector'
    let style
    if (!config.type || config.type === 'vector') {
      
      //let res = await request.get('./map/style/' + config.style + '.json')
      let res = await request.get('./api/area')
      style = res.data
    }
    let { mapbox, chart } = this._init(style, el, config)
    // 开启键盘支持
    if (config.keyborad) {
      keyborad(mapbox)
    }
    let layer = new Layer(mapbox, null, chart)
    return { mapbox, chart, layer }
  },
  /**
   * 初始化mapbox
   *
   * @param {String} sources 数据源
   * @param {String} el echart挂载实例
   * @returns
   */
  _init(style, el, { source, center, zoom, pitch }) {
    window.mapboxgl = mapboxgl
    let styles = {
      name: 'Mapbox Streets',
      container: document.getElementById(el),
      center, // 地图中心
      zoom,
      antialias: true,
      pitch, //地图俯视倾斜角度，默认为0，最大60
      bearing: 0
    }
    // 若为自定义，则需要配置完整的style
    if (this.type === 'custom' && window.$mapStyle) {
      styles.style = $mapStyle
      if (style && style.layers) {
        styles.layers.push(...style.layers)
      }
    } else {
      if (style) {
        styles.style = {
          version: 8,
          sprite: 'http://' + window.location.host + '/map/sprites/sprite',
          glyphs: `http://${source}/fonts/{fontstack}/{range}.pbf`,
          sources: {
            openmaptiles: {
              type: 'vector',
              url: `http://${source}/data/v3.json`
            }
          },
          layers: style.data.layers
        }
      } else {
        if (source instanceof Object) {
          let sources = {}
          let layers = []
          for (let k in source) {
            let s = source[k]
            sources[k] = {
              type: 'raster',
              tiles: [`http://${s}/{z}/{x}/{y}.png`]
            }
            layers.push({
              id: k,
              type: 'raster',
              source: k,
              minzoom: 0,
              maxzoom: 22
            })
          }
          styles.style = {
            version: 8,
            sprite: 'http://' + window.location.host + '/map/sprites/sprite',
            sources,
            layers
          }
        } else {
          styles.style = {
            version: 8,
            sprite: 'http://' + window.location.host + '/map/sprites/sprite',
            sources: {
              openmaptiles: {
                type: 'raster',
                tiles: [`http://${source}/{z}/{x}/{y}.png`]
              }
            },
            layers: [
              {
                id: 'gd-tiles-layer',
                type: 'raster',
                source: 'openmaptiles',
                minzoom: 0,
                maxzoom: 22
              }
            ]
          }
        }
      }
    }
    let mapbox = new mapboxgl.Map(styles)
    window.addEventListener('resize', function() {
      mapbox.resize()
    })
    //设置语言
    let language = new MapboxLanguage({ defaultLanguage: 'zh' })
    mapbox.addControl(language)
    return { mapbox }
  }
}
export default Mapbox



// WEBPACK FOOTER //
// ./src/framework/map/mapbox.js